import { PublicApiSettingsEntity } from './publicApiSettingsEntity';
import { IsEnableDownloadSales } from './valueObjects/isEnableDownloadSales';
import { IsEnableNurseryPayment } from './valueObjects/isEnableNurseryPayment';
import { NurseryId } from './valueObjects/nurseryId';
import { NurseryPaymentTitle } from './valueObjects/nurseryPaymentTitle';
import { SctActActor } from './valueObjects/sctActActor';
import { SctActAddress } from './valueObjects/sctActAddress';
import { SctActDeliveryTime } from './valueObjects/sctActDeliveryTime';
import { SctActEmail } from './valueObjects/sctActEmail';
import { SctActExchange } from './valueObjects/sctActExchange';
import { SctActExchangeFee } from './valueObjects/sctActExchangeFee';
import { SctActHowToPay } from './valueObjects/sctActHowToPay';
import { SctActPaymentTerm } from './valueObjects/sctActPaymentTerm';
import { SctActPrice } from './valueObjects/sctActPrice';
import { SctActPriceOther } from './valueObjects/sctActPriceOther';
import { SctActSupervisor } from './valueObjects/sctActSupervisor';
import { SctActTel } from './valueObjects/sctActTel';
import { SctActTelTime } from './valueObjects/sctActTelTime';
import { SquareApplicationId } from './valueObjects/squareApplicationId';
import { SquareLocationId } from './valueObjects/squareLocationId';

import type { PublicApiSettingsJson, PublicApiSettingsProps } from './publicApiSettingsEntity';

import { Factory } from '@/domain/factory';

export class PublicApiSettingsFactory extends Factory<
  PublicApiSettingsEntity,
  PublicApiSettingsProps,
  PublicApiSettingsJson
> {
  comparePvt = (a: PublicApiSettingsJson, b: PublicApiSettingsJson) => {
    const da = a.nurseryId;
    const db = b.nurseryId;
    return da > db ? 1 : -1;
  };

  createPvt(props: PublicApiSettingsProps): PublicApiSettingsEntity {
    return new PublicApiSettingsEntity(props, null);
  }

  createFromJsonPvt(props: PublicApiSettingsJson): PublicApiSettingsEntity {
    return this.createPvt({
      nurseryId: NurseryId.create(props.nurseryId),
      isEnableNurseryPayment: IsEnableNurseryPayment.create(props.isEnableNurseryPayment),
      isEnableDownloadSales: props.isEnableDownloadSales
        ? IsEnableDownloadSales.create(props.isEnableDownloadSales)
        : undefined,
      nurseryPaymentTitle: NurseryPaymentTitle.create(props.nurseryPaymentTitle),
      squareApplicationId: SquareApplicationId.create(props.squareApplicationId),
      squareLocationId: SquareLocationId.create(props.squareLocationId),
      sctActActor: SctActActor.create(props.sctActActor),
      sctActSupervisor: SctActSupervisor.create(props.sctActSupervisor),
      sctActAddress: SctActAddress.create(props.sctActAddress),
      sctActTel: SctActTel.create(props.sctActTel),
      sctActTelTime: SctActTelTime.create(props.sctActTelTime),
      sctActEmail: SctActEmail.create(props.sctActEmail),
      sctActPrice: SctActPrice.create(props.sctActPrice),
      sctActPriceOther: SctActPriceOther.create(props.sctActPriceOther),
      sctActHowToPay: SctActHowToPay.create(props.sctActHowToPay),
      sctActPaymentTerm: SctActPaymentTerm.create(props.sctActPaymentTerm),
      sctActDeliveryTime: SctActDeliveryTime.create(props.sctActDeliveryTime),
      sctActExchange: SctActExchange.create(props.sctActExchange),
      sctActExchangeFee: SctActExchangeFee.create(props.sctActExchangeFee),
    });
  }
}
